import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import { createHistory } from '../reducers/HistorySlice';

function AddHistory() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        students: '',
        securityCharges: '',
        paidAmount: '',
        receivedAmount: '',
        month: '',
        bookings: '',
        staff: '',
        workers: '',
        staffSalary: '',
        workerSalary: '',
        totalSalary: '',
        maintenanceCost: '',
        electricityBill: '',
        waterBill: '',
        gasBill: '',
        internetBill: '',
        otherBills: '',
    });

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await dispatch(createHistory(formData));
            toast.success('Monthly history saved!');
            navigate('/histories');
            setFormData({
                students: '',
                securityCharges: '',
                paidAmount: '',
                receivedAmount: '',
                month: '',
                bookings: '',
                staff: '',
                workers: '',
                staffSalary: '',
                workerSalary: '',
                totalSalary: '',
                maintenanceCost: '',
                electricityBill: '',
                waterBill: '',
                gasBill: '',
                internetBill: '',
                otherBills: '',
            });
        } catch (error) {
            toast.error('Failed to save history');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4 text-white">
            <h2 className="mb-4 text-center">Add Monthly Records</h2>
            <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                    {[
                        { id: 'students', label: 'Students', type: 'number' },
                        { id: 'bookings', label: 'Bookings', type: 'number' },
                        { id: 'month', label: 'Month', type: 'text', placeholder: 'e.g., April 2025' },
                        { id: 'staff', label: 'Staff', type: 'number' },
                        { id: 'workers', label: 'Workers', type: 'number' },
                        { id: 'staffSalary', label: 'Staff Salary', type: 'number' },
                        { id: 'workerSalary', label: 'Worker Salary', type: 'number' },
                        { id: 'totalSalary', label: 'Total Salary', type: 'number' },
                        { id: 'securityCharges', label: 'Security Charges', type: 'number' },
                        { id: 'maintenanceCost', label: 'Maintenance Cost', type: 'number' },
                        { id: 'paidAmount', label: 'Paid Amount', type: 'number' },
                        { id: 'receivedAmount', label: 'Received Amount', type: 'number' },
                        { id: 'electricityBill', label: 'Electricity Bill', type: 'number' },
                        { id: 'waterBill', label: 'Water Bill', type: 'number' },
                        { id: 'gasBill', label: 'Gas Bill', type: 'number' },
                        { id: 'internetBill', label: 'Internet Bill', type: 'number' },
                        { id: 'otherBills', label: 'Other Bills', type: 'number' },
                    ].map(({ id, label, type, placeholder }) => (
                        <div key={id} className="col-md-4 mb-3">
                            <label htmlFor={id} className="form-label">{label}</label>
                            <input
                                type={type}
                                className="form-control"
                                id={id}
                                value={formData[id]}
                                onChange={handleInputChange}
                                placeholder={placeholder || ''}
                            />
                        </div>
                    ))}
                </div>

                <div className="text-end">
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? 'Saving...' : 'Save History'}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default AddHistory;
